import { apiClient } from "@/common/api/Service";
import { snakeToCamelCase } from "@/common/common";
const getPricing = async () => {
    const client = apiClient();
    const response = await client.get("data/pricing");
    const { pricing } = snakeToCamelCase(response);
    return pricing;
};
export { getPricing };
